import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import edfService from '~/services/Edf';
import { LOADING_STATUSES } from '~/constants/edf';

const initialState = {
    status: null,
    errorMessage: null,
};
Object.freeze(initialState);

const loadingFilesSlice = createSlice({
    name: 'edfLoadingFile',
    initialState,
    reducers: {
        initEdf() {},
        setCustomErrorMessage(state, { payload }) {
            state.status = LOADING_STATUSES.ERROR;
            state.errorMessage = payload;
        },
        reset() {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadEdfFiles.pending, (state) => {
                state.status = LOADING_STATUSES.PENDING;
            })
            .addCase(loadEdfFiles.fulfilled, (state) => {
                state.status = LOADING_STATUSES.SUCCESS;
            })
            .addCase(loadEdfFiles.rejected, (state, action) => {
                state.status = LOADING_STATUSES.ERROR;
                state.errorMessage = action?.error?.message;
            });
    },
});

export const loadEdfFiles = createAsyncThunk(
    'edf/load',
    async ({ edfFile, annotationFile, meta }, thunkAPI) => {
        edfService.setFiles(edfFile, annotationFile);

        let headers;
        let annotations;

        try {
            await edfService.initialize();
            headers = await edfService.getHeaders();
            annotations = await edfService.getAnnotations();
        } catch (e) {
            return Promise.reject(e);
        }

        thunkAPI.dispatch(loadingFilesSlice.actions.initEdf({ headers, annotations, meta }));

        return Promise.resolve();
    }
);

export const { reset, initEdf, setCustomErrorMessage } = loadingFilesSlice.actions;

export default loadingFilesSlice.reducer;
